module.exports = __webpack_public_path__ + "img/packing-icon.3deb7328.png";